import { useAtomValue } from 'jotai'
import { useMemo } from 'react'

import { areAddressesEqual } from '@cowprotocol/cow-sdk'
import { useWalletInfo } from '@cowprotocol/wallet'

import { TwapPartOrderItem, twapPartOrdersAtom } from '../state/twapPartOrdersAtom'

const EMPTY_PART_ITEMS: TwapPartOrderItem[] = []

export function useTwapPartOrdersList(): TwapPartOrderItem[] {
  const { account, chainId } = useWalletInfo()
  const twapPartOrders = useAtomValue(twapPartOrdersAtom)

  return useMemo(() => {
    if (!account || !chainId) return EMPTY_PART_ITEMS

    const orders = Object.values(twapPartOrders)

    return orders.flat().filter((order) => areAddressesEqual(order.safeAddress, account) && order.chainId === chainId)
  }, [account, chainId, twapPartOrders])
}
